const mergeFileMeta = ({ prev, files }) => {
  const next = { ...prev };

  files.forEach((file) => {
    next[file.id] = file;
  });

  return next;
};

export default mergeFileMeta;
